export default class Api {
  static load(id) {
    const request = new Request(
      window.CE_HUB_API_URL + `/support/customer/${id}`,
      {
        method: 'GET',
        headers: new Headers({
          Authorization: localStorage.getItem('token')
        })
      }
    );
    return fetch(request)
      .then(response => {
        return response.json();
      })
      .catch(error => {
        console.log(error);
        return error;
      });
  }

  static signup(name, reference_id) {
    const request = new Request(window.CE_HUB_API_URL + `/support/customer`, {
      method: 'POST',
      headers: new Headers({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify({
        name: name,
        reference_id: reference_id
      })
    });
    return fetch(request)
      .then(response => {
        return response.json();
      })
      .catch(error => {
        return error;
      });
  }

  static update(id, name, reference_id) {
    const request = new Request(
      window.CE_HUB_API_URL + `/support/customer/${id}`,
      {
        method: 'PUT',
        headers: new Headers({
          Authorization: localStorage.getItem('token'),
          'Content-Type': 'application/json'
        }),
        body: JSON.stringify({
          name: name,
          reference_id: reference_id
        })
      }
    );
    return fetch(request)
      .then(response => {
        return response.json();
      })
      .catch(error => {
        console.log(error);
        return error;
      });
  }
  static deleteCustomer(id) {
    const request = new Request(
      window.CE_HUB_API_URL + `/support/customer/${id}`,
      {
        method: 'DELETE',
        headers: new Headers({
          Authorization: localStorage.getItem('token'),
          'Content-Type': 'application/json'
        })
      }
    );
    return fetch(request)
      .then(response => {
        return response.json();
      })
      .catch(error => {
        console.log(error);
        return error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/customers/CustomerForm/ducks/operations.js